import { ROUND_PNM_CREATE_INIT } from '../constants/roundPnmTypes';

export function roundPnmCreate(params) {
  return {
    type:    ROUND_PNM_CREATE_INIT,
    payload: params,
  };
}
